module.exports = __webpack_public_path__ + "img/tmf-icon-M-round.0a173b8c.webp";